import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  CheckInput,
  TabButtonFlatButton,
  TextInputField,
  TextInputFieldArea,
} from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import { BuzzListItem, BuzzPostPopUp, CreatePostModal } from "./components";

const BuzzDisplay = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const { width, height } = useWindowDimensions();
  const [tableDisplay, setTableDisplay] = useState("requested");
  const [filterPopUp, setFilterPopUp] = useState(false);
  const [mainfilterChoice, setMainfilterChoice] = useState("all");

  const [createPostModal, setCreatePostModal] = useState(false);

  const [searchText, setSearchtext] = useState("");
  const [search, setSearch] = useState("");

  const [historyFeed, setHistoryFeed] = useState(null);
  const [liveFeed, setLiveFeed] = useState(null);

  const [requested, setRequested] = useState(null);
  const [yourHistory, setYourHistory] = useState(null);

  const [selectedPost, setSelectedPost] = useState(null);

  const [ec, setEc] = useState(false);
  const [fs, setFs] = useState(false);
  const [gp, setGp] = useState(false);
  const [kn, setKn] = useState(false);
  const [lp, setLp] = useState(false);
  const [mp, setMp] = useState(false);
  const [nc, setNc] = useState(false);
  const [nw, setNw] = useState(false);
  const [wc, setWc] = useState(false);

  const [vehicleMake, setVehicleMake] = useState("");

  const [customRequest, setCustomeRequest] = useState("");

  const assembleName = ({ item }) => {
    if (item) {
      let name =
        item.postToo[0] +
        item.postType[0] +
        item.shortDescription +
        item.senderDetails +
        item.dateCreated +
        item.status;

      return name;
    }
  };

  const getLiveFeed = () => {
    setLoading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + "/buzzPost/getTodaysFeed")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setLiveFeed(resData.todaysPosts);
        setLoading(false);
      });
  };

  const getHistoricalFeed = () => {
    fetch(
      process.env.REACT_APP_BACKEND_URL + "/buzzPost/getApprovedPostHistory"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setHistoryFeed(resData.history);
        setLoading(false);
      });
  };

  const getAgencyRequests = async () => {
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/buzzPost/getUserAgencyPostRequestFeed",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            senderId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setRequested(respnseData.requests);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const getAgencyHistory = async () => {
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/buzzPost/getUserAgencyPostHistoryFeed",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            senderId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setYourHistory(respnseData.requests);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (auth) {
      getLiveFeed();
      getHistoricalFeed();
      getAgencyHistory();
      getAgencyRequests();
    }
  }, [refresh]);
  return (
    <div
      style={{
        flex: 1,
        // borderStyle: "solid",
        maxHeight: height - 70,
        height: height - 70,
        minHeight: height - 70,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* tab buttons */}
      <div style={{ position: "fixed", top: 28, display: "flex" }}>
        <div style={{ marginLeft: 10 }}>
          <TabButtonFlatButton
            title={"LIVE FEED"}
            backgroundColor={
              tableDisplay === "live"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "live" ? colors.secondaryDarkBlue : colors.white
            }
            onClick={() => setTableDisplay("live")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"REQUESTED"}
            backgroundColor={
              tableDisplay === "requested"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "requested"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("requested")}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"YOU SENT"}
            backgroundColor={
              tableDisplay === "you"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "you" ? colors.secondaryDarkBlue : colors.white
            }
            onClick={() => setTableDisplay("you")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"HISTORY"}
            backgroundColor={
              tableDisplay === "history"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "history"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("history")}
          />
        </div>
      </div>
      {/* action header bar */}
      <div
        style={{
          width: "100%",
          //   borderStyle: "solid",
          //   borderWidth: 1,
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          //   backgroundColor: colors.white,
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            backgroundColor: colors.white,
            borderRadius: 4,
            display: "flex",
            marginLeft: 10,
          }}
        >
          <TextInputField
            mini={true}
            marginTop={-5}
            // invert={true}
            placeholder={"type here to search"}
            height={20}
            value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
          />
        </div>
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"CLEAR"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => {
            setSearchtext("");
            setSearch("");
          }}
        />{" "}
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SEARCH"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
          onClick={() => setSearch(searchText)}
        />
        <div style={{ marginLeft: 10, position: "relative" }}>
          <BaseButtons
            label={"FILTER"}
            borderRadius={8}
            backgroundColor={colors.primaryBlue}
            onClick={() => setFilterPopUp(filterPopUp ? false : true)}
          />
          {filterPopUp ? (
            <div
              style={{
                position: "absolute",
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 4,
                bottom: -325,
                minHeight: 300,
                width: 300,
                left: 10,
                WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              }}
            >
              <div
                style={{ marginTop: 10, marginLeft: 10, fontWeight: "bold" }}
              >
                FILTER OPTIONS
              </div>
              <div
                style={{
                  marginTop: 4,
                  marginLeft: 10,
                  fontWeight: "bold",
                  fontSize: 12,
                  opacity: 0.7,
                }}
              >
                please select the options you would like to be able to view
              </div>
              <CheckInput
                label={"ALL"}
                onClick={() => setMainfilterChoice("all")}
                selected={mainfilterChoice === "all" ? true : false}
              />
              <CheckInput
                label={"PROVINCES"}
                onClick={() => setMainfilterChoice("province")}
                selected={mainfilterChoice === "province" ? true : false}
              />
              <CheckInput
                label={"VEHICLE MAKE"}
                onClick={() => setMainfilterChoice("make")}
                selected={mainfilterChoice === "make" ? true : false}
              />
              <CheckInput
                label={"CUSTOME REQUEST"}
                onClick={() => setMainfilterChoice("custom")}
                selected={mainfilterChoice === "custom" ? true : false}
              />

              {mainfilterChoice === "all" ? (
                <div
                  style={{
                    marginTop: 60,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  "No extra options currently availible"
                </div>
              ) : null}
              {mainfilterChoice === "province" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <div style={{ marginBottom: 4, fontSize: 12 }}>
                    List of provinces
                  </div>
                  <div style={{ display: "flex" }}>
                    <CheckInput
                      label={"EC"}
                      onClick={() => setEc(ec ? false : true)}
                      selected={ec}
                    />
                    <CheckInput
                      label={"FS"}
                      onClick={() => setFs(fs ? false : true)}
                      selected={fs}
                    />
                    <CheckInput
                      label={"GP"}
                      onClick={() => setGp(gp ? false : true)}
                      selected={gp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"KN"}
                      onClick={() => setKn(ec ? false : true)}
                      selected={kn}
                    />
                    <CheckInput
                      label={"LP"}
                      onClick={() => setLp(fs ? false : true)}
                      selected={lp}
                    />
                    <CheckInput
                      label={"MP"}
                      onClick={() => setMp(mp ? false : true)}
                      selected={mp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"NC"}
                      onClick={() => setNc(ec ? false : true)}
                      selected={nc}
                    />
                    <CheckInput
                      label={"NW"}
                      onClick={() => setNw(fs ? false : true)}
                      selected={nw}
                    />
                    <CheckInput
                      label={"WC"}
                      onClick={() => setWc(gp ? false : true)}
                      selected={wc}
                    />
                  </div>
                </div>
              ) : null}
              {mainfilterChoice === "make" ? (
                <div
                  style={{
                    marginTop: 40,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputField mini={true} labelTitle={"Vehicle Make"} />
                </div>
              ) : null}
              {mainfilterChoice === "custom" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputFieldArea
                    height={80}
                    size={"80%"}
                    mini={true}
                    labelTitle={"Custome search"}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"REFRESH"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => setRefresh(refresh ? false : true)}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"+ ADD NEW POST"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
          width={155}
          onClick={() => setCreatePostModal(true)}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      {/* buzz header list view */}
      <div
        style={{
          width: "100%",
          minHeight: 40,
          backgroundColor: colors.secondaryDarkBlue,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          <div style={{ marginLeft: 10 }}> SENT TO</div>
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          TITLE (CATEGORY)
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          DESCRIPTION
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          SENT BY
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
          }}
        >
          DATE REQUESTED
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.1,
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }}
        >
          STATUS
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          ACTIONS
        </div>
      </div>
      {/* buzz list items */}
      <div
        style={{
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          flex: 1,

          borderWidth: 1,
          alignItems: "center",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "thin",
        }}
      >
        {tableDisplay === "history" ? (
          historyFeed ? (
            historyFeed.map((item, index) => {
              return assembleName({ item: item })
                .toLowerCase()
                .match(search.toLowerCase()) ? (
                <div
                  key={index}
                  style={{ width: "100%", paddingTop: 0.2, paddingBottom: 1 }}
                >
                  <BuzzListItem
                    category={item.postToo[0]}
                    subCategory={item.postType[0]}
                    onViewClick={() => setSelectedPost(item)}
                    description={item.shortDescription}
                    sentBy={item.senderDetails}
                    dateRequested={item.dateCreated}
                    status={item.status}
                  />
                </div>
              ) : null;
            })
          ) : (
            <div>LOADING DATA ...</div>
          )
        ) : null}
        {tableDisplay === "you" ? (
          yourHistory ? (
            yourHistory.map((item, index) => {
              return assembleName({ item: item })
                .toLowerCase()
                .match(search.toLowerCase()) ? (
                <div
                  key={index}
                  style={{ width: "100%", paddingTop: 0.2, paddingBottom: 1 }}
                >
                  <BuzzListItem
                    category={item.postToo[0]}
                    subCategory={item.postType[0]}
                    onViewClick={() => setSelectedPost(item)}
                    description={item.shortDescription}
                    sentBy={item.senderDetails}
                    dateRequested={item.dateCreated}
                    status={item.status}
                  />
                </div>
              ) : null;
            })
          ) : (
            <div>LOADING DATA ...</div>
          )
        ) : null}
        {tableDisplay === "requested" ? (
          requested ? (
            requested.map((item, index) => {
              return assembleName({ item: item })
                .toLowerCase()
                .match(search.toLowerCase()) ? (
                <div
                  key={index}
                  style={{ width: "100%", paddingTop: 0.2, paddingBottom: 1 }}
                >
                  <BuzzListItem
                    category={item.postToo[0]}
                    subCategory={item.postType[0]}
                    onViewClick={() => setSelectedPost(item)}
                    description={item.shortDescription}
                    sentBy={item.senderDetails}
                    dateRequested={item.dateCreated}
                    status={item.status}
                  />
                </div>
              ) : null;
            })
          ) : (
            <div>LOADING DATA ...</div>
          )
        ) : null}
        {tableDisplay === "live" ? (
          liveFeed ? (
            liveFeed.map((item, index) => {
              return assembleName({ item: item })
                .toLowerCase()
                .match(search.toLowerCase()) ? (
                <div
                  key={index}
                  style={{ width: "100%", paddingTop: 0.2, paddingBottom: 1 }}
                >
                  <BuzzListItem
                    category={item.postToo[0]}
                    subCategory={item.postType[0]}
                    onViewClick={() => setSelectedPost(item)}
                    description={item.shortDescription}
                    sentBy={item.senderDetails}
                    dateRequested={item.dateCreated}
                    status={item.status}
                  />
                </div>
              ) : null;
            })
          ) : (
            <div>LOADING DATA ...</div>
          )
        ) : null}
      </div>
      {/* // create a buzz post pop up */}
      {selectedPost ? (
        <BuzzPostPopUp selectedPost={selectedPost} setClose={setSelectedPost} />
      ) : null}
      <CreatePostModal
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setLoading={setLoading}
        setToastPop={setToastPop}
        refresh={refresh}
        setRefresh={setRefresh}
        display={createPostModal}
        setCreatePostModal={setCreatePostModal}
        auth={auth}
        companyInformation={companyInformation}
      />
    </div>
  );
};

export default BuzzDisplay;
